// extracted by mini-css-extract-plugin
export default {"photo":"StaffFace_photo__Ryjiw"};